import { useEffect, useState } from "react";

interface Size {
  width: number;
  height: number;
}

const computeSize = (intrinsics: Size): Size => {
  const maxW = window.innerWidth * 0.9;
  const maxH = window.innerHeight * 0.9;
  const aspect = intrinsics.width / intrinsics.height;

  if (intrinsics.width / maxW >= intrinsics.height / maxH) {
    return { width: maxW, height: maxW / aspect };
  } else {
    return { width: maxH * aspect, height: maxH };
  }
};

export const useVideoPlayerSize = () => {
  const [videoIntrinsics, setVideoIntrinsics] = useState<Size | null>(null);
  const [modalPlayerSize, setModalPlayerSize] = useState<Size | null>(null);

  useEffect(() => {
    if (!videoIntrinsics) return;
    const handleResize = () => setModalPlayerSize(computeSize(videoIntrinsics));
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [videoIntrinsics]);

  const handleVideoReady = (player: any) => {
    const videoEl = player.getInternalPlayer() as HTMLVideoElement;
    const vw = videoEl.videoWidth;
    const vh = videoEl.videoHeight;
    if (!vw || !vh) return;

    const intrinsics = { width: vw, height: vh };
    setVideoIntrinsics(intrinsics);
    setModalPlayerSize(computeSize(intrinsics));
  };

  return { modalPlayerSize, handleVideoReady };
};
